
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/watchlist",
      function () {
        return require("private-next-pages/user/watchlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/watchlist"])
      });
    }
  